module.exports = __webpack_public_path__ + "img/copy.88b88c43.png";